module.exports = __webpack_public_path__ + "static/img/huanzhe6.60f35ece.webp";